// NMN|CP — Desktop filters hidden by default (AB49 band, filters only)
//
// Markup: ab49f-band.html — static, lives in the theme's collection section.
// Styles: ab49f.css — paste into the Varify CSS field.
// This file (JS field): logic/interaction ONLY. It does not create, clone, or inject
// any markup — it only selects elements that already exist in the DOM and wires them up.
//
// What this script does (desktop >= 1008 only; mobile/tablet untouched by it):
//   - moves the theme's REAL Sort button (.CollectionToolbar__Item--sort) into the
//     static #ab49f-sort-slot on desktop, and puts it back where it came from below 1008
//     (it has to be the real node — the theme's Popover script is bound to it directly)
//   - Filter button: toggles the sidebar open/closed, keeps state per tab (sessionStorage),
//     updates aria-expanded
//   - "Filter (n)" label when sidebar filters are applied, so a closed sidebar still shows them
//   - keeps the band's sticky `top` correct (the theme only sets this for the first 3s)
//
// What it does NOT do: it does not build #ab49-toolbar, the pills nav, or the Filter
// button — all of that is static markup now (ab49f-band.html). It does not touch
// product cards or anything below 1008px.
//
// Non-obvious (read before editing):
//   * #ab49-toolbar must already exist in the DOM when this runs — if it's missing,
//     the markup wasn't added to the theme section, not a JS problem.
//   * If the full AB49 variant is also on the page (html[data-ab49]), this script backs off.
//   * __sapp replays clicks: the Filter toggle has a 400ms re-entry guard.
//   * Re-paste safe: window.__ab49fRollback() undoes everything, then we rebuild.
(function () {
  'use strict';

  var NS = 'ab49f';
  var BP = 1008;
  var BAND_ID = 'ab49-toolbar';
  var OPEN_FILTERS = NS + '-filters-open';   // class on <html>
  var STORE_KEY = NS + '-filters-open';

  if (typeof window.__ab49fRollback === 'function') {
    try { window.__ab49fRollback(); } catch (e) {}
  }

  // ------------------------------------------------------------------ scope guard
  var path = location.pathname;
  if (path.indexOf('/collections/') === -1 || path.indexOf('/products/') !== -1) return;

  var html = document.documentElement;
  if (html.hasAttribute('data-ab49')) return;   // full AB49 variant already owns the band
  html.setAttribute('data-ab49f', '1');

  // ------------------------------------------------------------------ state
  var timers = [], listeners = [], ro = null, mq = null, dead = false;
  var sortHome = null;          // { node, parent, next } of the relocated native Sort
  var lastFilterToggle = 0;

  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    listeners.push([target, type, fn, opts]);
  }
  function setClass(el, cls, want) {
    if (!el) return;
    if (el.classList.contains(cls) !== !!want) el.classList.toggle(cls, !!want);
  }
  function isDesktop() { return window.innerWidth >= BP; }
  function now() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

  // The theme sets the band's sticky `top` only at load and for the first 3s
  // (layout/theme.liquid adjustToolbarTop). Keep it correct ourselves too —
  // header, plus the announcement bar from 1140 up.
  function syncBandTop() {
    var band = document.getElementById(BAND_ID);
    if (!band) return;
    var a = document.getElementById('shopify-section-announcement');
    var h = document.getElementById('shopify-section-header');
    var top = (h ? h.offsetHeight : 0) + (a && window.innerWidth >= 1140 ? a.offsetHeight : 0);
    if (band.style.top !== top + 'px') band.style.top = top + 'px';
  }

  // With the sidebar closed nothing shows a filter is on: "Filter (2)". The active pill's
  // own filter is not counted (the black pill already says it). Price min/max count as one.
  function updateFilterCount() {
    var btn = document.getElementById('ab49f-filter-btn');
    if (!btn) return;
    var pillParams = {}, active = document.querySelector('#' + BAND_ID + ' .ab49f-pills .is-active');
    if (active) {
      var href = active.getAttribute('href') || '', q = href.indexOf('?');
      if (q >= 0) new URLSearchParams(href.slice(q)).forEach(function (v, k) { pillParams[k] = v; });
    }
    var n = 0, price = false;
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0 || !v || pillParams[k] === v) return;
      if (k.indexOf('.price.') !== -1) { if (price) return; price = true; }
      n++;
    });
    var label = n ? 'Filter (' + n + ')' : 'Filter';
    if (btn.textContent !== label) btn.textContent = label;
  }

  // The ORIGINAL Sort node lives in the band on desktop and goes home below 1008.
  function placeSort() {
    var slot = document.getElementById('ab49f-sort-slot');
    var sort = (sortHome && sortHome.node) || document.querySelector('.CollectionToolbar__Item--sort');
    if (!sort || !slot) return;
    if (!sortHome) sortHome = { node: sort, parent: sort.parentNode, next: sort.nextSibling };
    if (isDesktop()) {
      if (sort.parentNode !== slot) slot.appendChild(sort);
    } else if (sort.parentNode !== sortHome.parent && sortHome.parent) {
      sortHome.parent.insertBefore(sort, sortHome.next && sortHome.next.parentNode === sortHome.parent ? sortHome.next : null);
    }
  }

  function setFilters(open) {
    setClass(html, OPEN_FILTERS, open);
    var btn = document.getElementById('ab49f-filter-btn');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    try { sessionStorage.setItem(STORE_KEY, open ? '1' : '0'); } catch (e) {}
  }
  function onFilterClick(e) {
    var t = now();
    if (t - lastFilterToggle < 400) { e.stopPropagation(); return; }   // __sapp replays clicks
    lastFilterToggle = t;
    setFilters(!html.classList.contains(OPEN_FILTERS));
  }

  // ------------------------------------------------------------------ boot
  var resizeT;
  function onResize() {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { placeSort(); syncBandTop(); }, 120);
  }

  function boot() {
    var band = document.getElementById(BAND_ID);
    if (!band) return false;   // static markup not rendered yet — keep polling
    if (html.hasAttribute('data-ab49')) { window.__ab49fRollback(); return true; }   // full AB49 booted after us

    html.setAttribute('data-ab49f-band', '1');

    var stored = null;
    try { stored = sessionStorage.getItem(STORE_KEY); } catch (e) {}
    setClass(html, OPEN_FILTERS, stored === '1' && !!document.querySelector('.CollectionInner__Sidebar'));

    var filterBtn = document.getElementById('ab49f-filter-btn');
    if (filterBtn) {
      filterBtn.setAttribute('aria-expanded', html.classList.contains(OPEN_FILTERS) ? 'true' : 'false');
      on(filterBtn, 'click', onFilterClick);
    }

    placeSort();
    updateFilterCount();
    syncBandTop();

    on(window, 'resize', onResize);
    on(window, 'load', syncBandTop);
    on(document, 'theme:loading:end', updateFilterCount);   // theme rewrote the URL on filter/sort
    on(document, 'theme:loading:end', syncBandTop);

    if (window.ResizeObserver) {
      ro = new ResizeObserver(syncBandTop);
      ['shopify-section-announcement', 'shopify-section-header'].forEach(function (id) {
        var el = document.getElementById(id); if (el) ro.observe(el);
      });
    }
    if (window.matchMedia) {
      mq = window.matchMedia('(min-width:' + BP + 'px)');
      if (mq.addEventListener) mq.addEventListener('change', onResize);
    }
    return true;
  }

  // Varify runs in <head>: wait for the static band markup to exist (poll 100ms, up to 15s)
  var tries = 0;
  (function poll() {
    if (dead) return;
    if (document.body && boot()) return;
    if (++tries > 150) {
      console.warn('[ab49f] #' + BAND_ID + ' not found — check ab49f-band.html is in the section');
      return;
    }
    timers.push(setTimeout(poll, 100));
  })();

  // ------------------------------------------------------------------ rollback (re-paste)
  window.__ab49fRollback = function () {
    dead = true;
    timers.forEach(clearTimeout);
    clearTimeout(resizeT);
    listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    if (ro) ro.disconnect();
    if (mq && mq.removeEventListener) mq.removeEventListener('change', onResize);
    if (sortHome && sortHome.parent && sortHome.node.parentNode !== sortHome.parent) {
      sortHome.parent.insertBefore(sortHome.node, sortHome.next && sortHome.next.parentNode === sortHome.parent ? sortHome.next : null);
    }
    html.removeAttribute('data-ab49f-band');
    html.classList.remove(OPEN_FILTERS);
    html.removeAttribute('data-ab49f');
    window.__ab49fRollback = null;
  };
})();